import z from "zod";

export const patchAttendanceStateBodySchema = z
	.object({
		state: z.enum(["rejected", "approved", "pending"]),
		rejectedReason: z.string().optional(),
	})
	.superRefine((values, context) => {
		if (values.state === "rejected" && !values.rejectedReason?.length) {
			context.addIssue({
				code: "custom",
				message: "Reason is required",
				continue: false,
				path: ["state"],
			});
		}
	});

export type PatchAttendanceStateBodySchema = z.infer<typeof patchAttendanceStateBodySchema>;
